import React, { useState } from 'react';
import { BookOpen } from 'lucide-react';
import { Button } from './Button';
import { Checkbox } from './Checkbox';
export function FreeBookCTA() {
  const [optIn, setOptIn] = useState(false);
  return <section className="py-16 sm:py-20 bg-background-primary-filled text-neutral-white" data-id="element-75">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-76">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-white/20 rounded-full mb-6" data-id="element-77">
          <BookOpen className="w-8 h-8 text-text-warning-default" data-id="element-78" />
        </div>
        <h2 className="text-3xl sm:text-4xl font-heading mb-4" data-id="element-79">
          7 Easy Steps to Mortgage Freedom
        </h2>
        <p className="text-xl text-white/80 mb-8 max-w-2xl mx-auto" data-id="element-80">
          Revealed by a mortgage industry insider who did it in just 7 years!
        </p>

        <div className="max-w-md mx-auto" data-id="element-81">
          <div className="flex gap-3 mb-4" data-id="element-82">
            <input type="email" placeholder="Enter your email address" className="flex-1 px-4 py-3 rounded-lg text-text-default focus:outline-none focus:ring-2 focus:ring-white/50" data-id="element-83" />
            <Button variant="primary" size="lg" className="bg-white text-[#4B1F68] border-none hover:bg-gray-100 flex-shrink-0" disabled={!optIn} data-id="element-84">
              Send me the Free Book
            </Button>
          </div>

          <div className="flex justify-center" data-id="element-85">
            <Checkbox dark checked={optIn} onChange={e => setOptIn(e.target.checked)} label="I'd like to receive mortgage tips and updates" size="sm" data-id="element-86" />
          </div>
        </div>
      </div>
    </section>;
}